var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"the-nav"},[_c('router-link',{staticClass:"the-nav_logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/img/logo.png"),"alt":"Heroes"}})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }